<angular-template tag="div">
    <vrm-red-banner installation="installation" />
</angular-template>
<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component()
export default class VrmRedBanner extends Vue {
    @Prop({ type: Object })
    installation;
}
</script>
